import { ConfigProvider } from 'antd';
import { CompanyProvider } from 'components/Global/CompanyContext';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import store from './redux/store';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	// <React.StrictMode>

	<CompanyProvider>
		<Provider store={store}>
			<ConfigProvider
				theme={{
					token: {
						colorPrimary: '#584495',
					},
				}}
			>
				<App />
			</ConfigProvider>
		</Provider>
	</CompanyProvider>
	//</React.StrictMode>
);
